
import isBrowser from "./is-browser"

export const getAdminApiUrl = () => {
	if (process.env.ADMIN_API_URL.includes("localhost")) {
		return !isBrowser
			? process.env.ADMIN_API_URL.replace("localhost", "api")
			: process.env.ADMIN_API_URL
	}

	return process.env.ADMIN_API_URL
}

export const getPageCanonicalUrl = (router, absoluteFallbackUrl) => {
	if (!router || !router.asPath) {
		return absoluteFallbackUrl
	}

	try {
		const url = new URL(absoluteFallbackUrl)
		const path = router.asPath.split("?")[0].split("#")[0]
		return `${url.origin}${path}`
	} catch (e) {
		return absoluteFallbackUrl
	}
}
